import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { hasRouteAccess } from "./permissions"; 
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import { Toaster } from 'sonner';
import { appConfig } from "../apiConfig";
import Cookies from "js-cookie";

export default function DashboardLayout() {
  const { user, checkAuth, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      const token = Cookies.get("WEB_STT");
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }
      await checkAuth();
    };
    init();
  }, []);

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/login", { replace: true });
        return;
      }

      if (!hasRouteAccess(location.pathname, user)) {
        navigate("/dashboard", { replace: true });
      }

      document.title = `${appConfig.name} | Tableau de bord`;
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = `/images/${appConfig.slug}-fav.png`;
      }
    }
  }, [location.pathname, user, loading, navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Navbar />
        <main className="w-full bg-gray-50">
          <Toaster richColors />
          <Outlet />
        </main>
      </div>
    </div>
  );
}